export enum FeatureFlagName {
  FontDrm = 'FontDrm',
  AllowScreenShot = 'AllowScreenShot',
  AllowFancyShare = 'AllowFancyShare',
  AllowReply = 'AllowReply',
  NudgeMarketingAgreeOnSignUp = 'NudgeMarketingAgreeOnSignUp',
  ShortUrl = 'ShortUrl',
  PickAndChoo2 = 'PickAndChoo2',
  PickAndChoo3 = 'PickAndChoo3',
  PickAndChoo3Apply = 'PickAndChoo3Apply',
  BalanceGameRitto2025 = 'BalanceGameRitto2025',
  AllowPrivateContentFiltering = 'AllowPrivateContentFiltering',
  HomeTextMode = 'HomeTextMode',
  PickAndChoo4 = 'PickAndChoo4',
  PickAndChoo4Apply = 'PickAndChoo4Apply',
  FanFiction = 'FanFiction',
}

export enum BatchMarkerName {
  SyncUserWithStibee = 'SyncUserWithStibee',
  SyncToMaskedPersonalInfo = 'SyncToMaskedPersonalInfo',
  ReSyncToMaskedPersonalInfo = 'ReSyncToMaskedPersonalInfo',
  SyncIsAdultContentWithFancyShare = 'SyncIsAdultContentWithFancyShare',
  SyncIsAdultEpisodeWithFancyShare = 'SyncIsAdultEpisodeWithFancyShare',
  RelayPersistProfileByHistory = 'RelayPersistProfileByHistory',
  RelayPersistProfileBySequence = 'RelayPersistProfileBySequence',
  RelayPersistEpisodeByHistory = 'RelayPersistEpisodeByHistory',
  RelayPersistEpisodeBySequence = 'RelayPersistEpisodeBySequence',
  RelayPersistContentByHistory = 'RelayPersistContentByHistory',
  RelayPersistContentBySequence = 'RelayPersistContentBySequence',
  RearrangeEpisodeVolume = 'RearrangeEpisodeVolume',
  SetAuthorByEpisodeCount = 'SetAuthorByEpisodeCount',
  AttendanceCheckNotiSend = 'AttendanceCheckNotiSend',
  SyncZendeskWithdrawal = 'SyncZendeskWithdrawal',
}

export enum UpdateStatus {
  Latest = 'Latest',
  Recommend = 'Recommend',
  Force = 'Force',
}

export enum AppOsType {
  Ios = 'ios',
  Android = 'android',
}

export const AppInstallLink = {
  [AppOsType.Ios]: 'https://apps.apple.com/kr/app/%EB%94%94%EB%A6%AC%ED%86%A0/id1616806831',
  [AppOsType.Android]: 'https://play.google.com/store/apps/details?id=kr.co.diritto',
};

export enum AdminUploadedFileType {
  CouponIssue = 'CouponIssue',
}

export enum FileTargetType {
  Section = 'Section',
}
